import React, { useEffect, useState, lazy } from 'react';
export const StickyBar = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-[#E8DFD3] transition-transform duration-300 z-50 ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-326">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-327">
        <div className="flex items-center" data-id="element-328">
          <div className="w-12 h-16 mr-3 rounded overflow-hidden hidden sm:block" data-id="element-329">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cnXT5L7fLgjUhX2VoBc1J8/Diseno_sin_titulo_%281%29.png" alt="Portada miniatura" className="w-full h-full object-cover" width="48" height="64" loading="lazy" data-id="element-330" />
          </div>
          <div data-id="element-331">
            <h3 className="font-serif font-bold text-[#0C1B2A] text-sm sm:text-base" data-id="element-332">
              Guía Contra el Mal de Ojo
            </h3>
            <p className="text-[#D4AF37] font-bold text-sm" data-id="element-333">$11.99</p>
          </div>
        </div>
        <a href="#checkout" className="btn-purchase bg-[#0C1B2A] hover:bg-[#1A2A3A] text-white font-bold py-2 px-4 sm:px-6 rounded-lg transition-colors duration-300 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0C1B2A]" aria-label="Quiero la Guía" data-id="element-334">
          Quiero la Guía
        </a>
      </div>
    </div>;
};